// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3eczO","footer":"ReportModalFilter_footer__2e9Rx"};